export const ms = {
    "TRIGGER_LISTEN": "Mendengar pemicu",
    "ASSIST_EMPTY_MSG": "Agen AI sedang mendengar percakapan anda dan sedia untuk membantu secara automatik apabila dipicu.",
    "MYBOT_TRIGGET_LISTEN": "Tiada tugas My Bot yang aktif pada masa ini",
    "MYBOT_EMTPY_MSG": "Untuk memulakan tugas pada My Bot, pergi ke tab carian dan pilih pilihan \"Jalankan dengan input agen\" untuk tugas yang dikehendaki.",
    "PROACTIVE_MODE": "Mod Proaktif",
    "SETTINGS": "Tetapan",
    "HELP_AND_SUPPORT": "Bantuan & Sokongan",
    "HELP": "Bantuan",
    "LANGUAGE": "Bahasa",
    "THEME": "Tema",
    "AUTOMATIC": "Automatik",
    "DARK": "Gelap",
    "LIGHT": "Cerah",
    "AUTO_SCROLL_TOOLTIP":"Mengawal skrol automatik Tab Bantuan, Bot Saya & Kandungan Tab Transkrip",
    "THEME_DESC": "Ini akan menggunakan mod lalai sistem anda",
    "DOCUMENTATION": "Dokumentasi",
    "FILE_NAME":"Nama fail",
    "DOC_DESC": "Lihat artikel dokumentasi mendalam kami.",
    "FAQ_U": "Soalan Lazim",
    "FAQ_DESC": "Lihat soalan yang sering ditanya mengenai Agen AI.",
    "KORE_ACADEMY": "Akademi Kore",
    "KORE_ACA_DESC": "Ketahui lebih lanjut tentang Agen AI melalui kursus akademi.",
    "SEARCH": "Carian",
    "MY_BOT": "My Bot",
    "ASSIST": "Bantu",
    "TAB_TEXT":"Tiada tab diaktifkan! Sila aktifkan sekurang-kurangnya satu tab",
    "TRANSCRIPT": "Transkrip",
    "HISTORY": "Sejarah",
    "STARTOVER": "Mula semula",
    "TAP_SEARCH":"Ketik untuk mencari",
    "RESTART_INPUTS": "Mula semula dengan input yang ditangkap",
    "ASKCUSTOMER": "Tanya Pelanggan",
    "TELLCUSTOMER": "Beritahu Pelanggan",
    "WELCOME_MSG": "Mesej Selamat Datang",
    "SEND": "Hantar",
    "SENT": "Dihantar",
    "AWAITING": "Menunggu Respons | Taip untuk meneruskan",
    "OVERRIDE": "Taip untuk meneruskan",
    "OVERRIDE_FILE": "Lampirkan Fail untuk meneruskan",
    "ACCEPT_RESPONSE": "Respons Diterima",
    "AGENT_ENTERED": "Agen Masuk",
    "EXPECTED_FORMAT": "Format Diharapkan",
    "INPUT_VALUES": "Nilai Input",
    "RESTART": "Mula semula",
    "START_OVER": "Mula semula",
    "RESTART_CAPTURE": "Mula semula dengan input yang ditangkap",
    "CANCEL": "Batal",
    "INTERRUPT_DIALOG": "TUGAS DIALOG YANG TERGANGGU",
    "RUN": "JALANKAN",
    "RUN_AGENT": "Jalankan dengan input agen",
    "STEP": "Langkah",
    "DIALOG_TASK": "Tugas Dialog",
    "FAQ": "Soalan Lazim",
    "SNIPPET": "Jawapan",
    "ARTICLE": "Laman Web",
    "FILE": "Fail",
    "SUGGESTED": "Disyorkan",
    "ALL_DIALOG": "Semua Tugas Dialog",
    "DIALOG_TEXT": "Dialog",
    "INTENT_IDENTIFIED": "Ucapan pelanggan",
    "NOT_WHAT_LOOKING": "Cadangan Salah?",
    "BOT": "Bot",
    "CUSTOMER": "Pelanggan",
    "YOU": "Anda",
    "TERMINATE_CONV": "Hentikan Tugas Dialog",
    "TERMINATE_CONV_DESC": "Adakah anda pasti ingin menghentikan tugas dialog? Agen AI tidak akan dapat membuat cadangan lagi.",
    "YES_TERMINATE": "Ya, Hentikan",
    "NO_CANCEL": "Tidak, Batal",
    "OVERRIDE_CONTINUE": "Teruskan dengan mod overide",
    "SUMMARY_TEXT": "Ringkasan",
    "SUBMIT": "Hantar",
    "INTERRUPT_OCCURED": "Gangguan Terjadi",
    "IDENTIFIED_INTENT": "Hasil yang dikenalpasti",
    "INTERRUPT_DESC": "Menjalankan ini akan menghentikan tugas dialog yang sedang berlangsung.",
    "ACCEPT_RUN": "Terima dan Jalankan",
    "RUN_LATER": "Jalankan Kemudian",
    "KNOW_MORE": "Ketahui Lebih Lanjut",
    "MORE_TEXT": "Lebih",
    "LESS_TEXT": "Kurang",
    "VIEW_MORE": "Lihat Lebih",
    "VIEW_LESS": "Lihat Kurang",
    "SHOW_MORE_FAQ": "Tunjukkan lebih banyak Soalan Lazim",
    "SHOW_LESS_FAQ": "Tunjukkan kurang Soalan Lazim",
    "SHOW_MORE_ARTICLE": "Tunjukkan lebih banyak laman web",
    "SHOW_LESS_ARTICLE": "Tunjukkan kurang laman web",
    "SHOW_MORE_SNIPPET": "Tunjukkan lebih banyak Jawapan",
    "SHOW_LESS_SNIPPET": "Tunjukkan kurang Jawapan",
    "SHOW_MORE_FILES": "Tunjukkan Lebih Banyak Fail",
    "SHOW_LESS_FILES": "Tunjukkan Kurang Fail",
    "VIEW_ALL_DIALOG": "Lihat semua Dialog",
    "VIEW_FEW_DIALOG": "Lihat sedikit Dialog",
    "HELP_FULL": "Bermanfaat?",
    "THANKYOU": "Terima kasih!",
    "EXPAND_MORE": "Kembangkan / Lebih",
    "CLOSE_TEXT": "Tutup",
    "STARTED": "Dimulakan",
    "ENDED": "Dihentikan",
    "VIEW_FULL_ARTICLE": "Lihat laman web",
    "VIEW_FULL_FILE": "Lihat fail",
    "COPIED": "Disalin",
    "SENTI_ANALY": "Analisis Sentimen",
    "WRONG_SUGGESTION": "Cadangan Salah",
    "INCORRECT_INTENT": "Hasil Salah",
    "ACCIDENTAL_CLICK": "Klik Tidak Sengaja",
    "TIME_TAKING": "Mengambil Masa",
    "OTHER": "Lain-lain",
    "PLAYBOOK_EMPTY_MSG": "Pilih Buku Permainan",
    "PLAYBOOK_EMPTY_DESC": "Agen AI tidak dapat memuatkan buku permainan kerana semua buku permainan yang tersedia adalah dinamik. Klik 'Pilih Buku Permainan' untuk mengakses buku permainan.",
    "STAGE": "Fasa",
    "PROCEED_TO_CLOSE": "Teruskan untuk menutup",
    "RECOMENDED_PLAYBOOK": "BUKU PERMAINAN YANG DISYORKAN",
    "PRIMARY_SCRIPTS": "SKRIP UTAMA",
    "DYNAMIC_SCRIPTS": "SKRIP DINAMIK",
    "RESUME": "Sambung",
    "ENABLE_CLOSE": "Klik butang teruskan untuk mengaktifkan Tahap Tutup",
    "LIST_VIEW": "Paparan Senarai",
    "TERMINATE": "Hentikan",
    "MINIMIZE": "Minimakan",
    "MAXIMIZE": "Maksimakan",
    "NO_SEARCH_RESULT": "Tiada hasil carian ditemui",
    "SENTIMENT_AWAITING": "Menunggu sentimen",
    "POSITIVE": "Positif",
    "NEGATIVE": "Negatif",
    "ASSOCIATED_WORK_NOTES": "Nota Penyelesaian Lepas",
    "AGENT_JOINED_CONV": "Agen menyertai perbualan",
    "AUTOSCROLL_ASSIST": "Kandungan Tab Bantuan Auto-Skrol",
    "FILE_SIZE_MSG": "Saiz fail mesti dalam 25MB. Sila cuba lagi.",
    "OVERRIDE_BTN": "Overide",
    "CHOOSE_FILE": "Pilih Fail",
    "SUMMARY_ERROR_TEXT": "Maaf, tetapi terdapat masalah dalam menghasilkan ringkasan untuk perbualan ini. Sila buat ringkasan anda sendiri.",
    "ASK_A_QUESTION": "Tanya soalan",
    "PLAYBOOK": "Buku panduan",
    "COPY": "Salin",
    "TELL_US_MORE": "Beritahu kami lebih lanjut…",
    "THANKS_FEEDBACK": "Terima kasih atas maklum balas anda",
    "SOMETHING_WRONG": "Ada sesuatu yang salah",
    "CLICK_ERROR_DETAILS": "Klik untuk melihat butiran ralat",
    "NO_ACTIVE_PLAYBOOK": "Tiada playbook aktif",
    "REPHRASE_QUESTION": "Bolehkah anda merumuskan semula soalan anda atau bertanya perkara lain?",
    "INTERNAL_INFO": "Maklumat dalaman",
    "SOURCES": "Sumber",
    "CONVERSATION_SUMMARY": "Ringkasan perbualan",
    "WAITING": "Menunggu",
    "WIDGET_DISABLED": "Widget dinonaktifkan",
    "AI_SETTINGS_DISABLED": "Tetapan AI dinonaktifkan! Sila hubungi pentadbir AI",
    "SERVER_CONNECTION_ERROR": "Ralat semasa menyambung ke pelayan",
    "VIEW": "Lihat",
    "ATTACHMENT_INPUT": "Input lampiran",
    "TYPE_SUMMARY": "Taip ringkasan",
    "VIEW_FULL_ARTICLE_2": "Lihat artikel penuh",
    "VIEW_FULL_FILE_2": "Lihat fail penuh",
    "BY":"Oleh",
    GENERATE_SUMMARY: "Jana Ringkasan",
    PREV_SUMMARIES: "Ringkasan yang Dihasilkan Sebelumnya",
    DIALOG_WORKFLOWS: "Aliran Kerja Dialog",
    SHOW_ALL_DIALOG: "Tunjukkan semua Tugas Dialog",
    SHOW_ALL_DIALOGS: "Tunjukkan Semua Dialog",
    CUSTOM_TAB: "Tab Tersuai",
    AGENT_INPUT: "Input Agen",
    "CUSTOM_EMPTY_MSG" : "Tiada alur kerja aktif",
    "CUSTOM_TAB_DESC" : "Untuk memulai alur kerja, jalankan salah satu dari daftar yang ada di bagian bawah layar.",
    "SUBMIT_OVERALL_FEEDBACK" : "Kirimkan umpan balik keseluruhan",
    "FEEDBACK_POPUP_SUBTITLE" : "Umpan balik tentang widget dan fiturnya",
    "FEEDBACK_SATISFIED" : "Puas",
    "FEEDBACK_UNSATISFIED" : "Tidak puas",
    "FEEDBACK_PROVIDE_REASONS" : "Berikan alasan lebih lanjut…",
    "FEEDBACK_TITLE" : "Umpan balik",
    "AGENTIC_THINKING" : "Berfikir",
    "AGENTIC_AGENT_TITLE" : "Ejen",
    "AGENTIC_COPILOT_MODE_TITLE" : "Mod Copilot Agens",
    "AGENTIC_SENDING_MESSAGE" : "Menghantar...",
    "AGENTIC_COPILOT_DESC" : "Agentic Copilot sedang mendengar perbualan anda secara aktif dan bersedia untuk membantu secara automatik",
    "AGENTIC_SEARCH_RESULTS" : "Hasil Ejen"
}
